import * as o from "react";
import c from "../lib/IconBase.es.js";
import s from "../defs/MicrophoneSlash.es.js";
const e = o.forwardRef((r, a) => /* @__PURE__ */ o.createElement(c, { ref: a, ...r, weights: s }));
e.displayName = "MicrophoneSlashIcon";
const i = e;
export {
  i as MicrophoneSlash,
  e as MicrophoneSlashIcon
};
